<template>
  <section class="box" :class="{ on: show }">
    <div class="cont">
      <header>
        <h3>选择地址</h3>
        <i class="icon-close" @click="toggle"></i>
      </header>
      <nav>
        <span @click="selected = []">中国</span>
        <span v-for="(v, i) in selected" :key="v.id" @click="updateNav(i)">{{v.name}}</span>
      </nav>
      <ul class="citys">
        <li 
          v-for="v in list" :key="v.id"
          @click="setAddr(v)"><span>{{v.first}}</span><span>{{v.name}}</span></li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      citys: [],
      selected: []
    }
  },
  computed: {
    list () {
      const { citys, selected } = this;
      const $citys = document.querySelector('.citys');
      if ( selected.length === 0 ) {
        $citys && this.scrollTo(0, $citys);
        return citys;
      }
      const [{ children }] = selected.slice(-1);
      $citys && this.scrollTo(0, $citys);
      return children || [];
    }
  },
  created () {
    const { china_citys: citys } = window;
    this.citys = citys;
  },
  methods: {
    setAddr (v) {
      this.selected = [...this.selected, v];
      if ( 'children' in v === false ) {
        this.$emit('change', { 
          list: this.selected, 
          text: this.selected.reduce((str, v) => {
            str += v.name;
            return str;
          }, '')
        });
        this.toggle();
      }
    },
    updateNav (i) {
      this.selected = [...this.selected].splice(0, i+1);
    },
    toggle () {
      this.show = !this.show;
    }
  }
}
</script>

<style scoped src="./address.css"></style>